import { combineReducers } from "redux";

import permission from "./permission";
import acordo from "./acordo";
import redirect from "./redirect";

export default combineReducers({
  permissions: permission,
  acordo,
  redirect
});



// WEBPACK FOOTER //
// ./src/store/reducers/index.js